<template>
  <div class="product-header-with-image-container">
    <div
      :class="header.displayLarge ? 'large' : ''"
      class="product-details-image-container"
    >
      <v-img :src="imgSrc" />
    </div>
    <AssistProductTitle
      :coloredText="header.coloredText"
      :normalText="header.normalText"
      :largeTitle="header.displayLarge"
      :componentClass="'assist-title'"
    />
  </div>
</template>

<script>
  import AssistProductTitle from './AssistProductTitle.vue';

  export default {
    name: 'ProductHeaderWithImage',
    components: {
      AssistProductTitle,
    },
    props: {
      header: {
        required: true,
        type: Object,
      },
    },
    watch: {},
    created() {
      this.loadImage();
    },

    data() {
      return {
        imgSrc: null,
      };
    },
    computed: {},
    methods: {
      loadImage() {
        this.imgSrc = require(`@/assets/${this.header.imageUrl}`);
      },
      learnMoreClicked() {
        this.$emit('learnMoreClicked');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .product-header-with-image-container {
    .product-details-image-container {
      max-width: 64px;
    }
    .product-details-image-container.large {
      max-width: 96px;
    }

    .assist-title {
      margin-top: 10px;
    }
  }
</style>
